import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppVariables } from './app.variables';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { authHeadersInterceptor } from './core/auth/auth-headers.interceptor';
import { AuthSessionMonitorService } from './core/auth/auth-session-monitor.service';
import { TranslationService } from './core/i18n/translation.service';
import { PORTAL_MODE } from './core/auth/portal-mode';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: PORTAL_MODE, useValue: 'tenant' },
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authHeadersInterceptor])),
    provideRouter(routes),
    provideAppInitializer(() => inject(TranslationService).initialize()),
    provideAppInitializer(() => inject(AuthSessionMonitorService).start()),
    provideAppInitializer(() => {
      const title = inject(Title);
      const envName = AppVariables.environmentName;
      title.setTitle(envName === 'PROD' ? 'Juno Audit' : `Juno Audit - ${envName}`);
    }),
  ],
};
